import type {ComponentEnhancer} from 'recompose'
import {branch as branchHOC} from 'recompose'

import compose from 'lodash/flowRight'
import * as React from 'react'
import {connect} from 'react-redux'

import {toggleSubproject} from '../../../../../actions'
import {useDerivedState} from '../../../../../hocs/withDerivedState'
import withHook from '../../../../../hocs/withHook'
import withStatusSubscription from '../../../../../hocs/withStatusSubscription'
import type {State} from '../../../../../reducers/types'
import {
  getHasBuildConfigurations,
  getIsSubprojectCollapsed,
  getProject,
  makeGetIsSubprojectsExist,
} from '../../../../../selectors'
import type {ProjectId} from '../../../../../types'
import type {VisibleProps} from '../../../Visible/Visible.hocs'
import {withVisibility} from '../../../Visible/Visible.hocs'

import Subproject from './Subproject'

type OwnProps = {
  projectId: ProjectId
  wasVisible?: boolean
}
export default compose(
  React.memo,
  withVisibility(true),
  withHook(({isVisible}: VisibleProps) => ({
    wasVisible: useDerivedState(false, state => state || isVisible === true),
  })),
  branchHOC(
    ({wasVisible}: {wasVisible: boolean}) => wasVisible,
    withStatusSubscription() as ComponentEnhancer<OwnProps, OwnProps>,
  ),
  connect(
    () => {
      const getHasSubprojects = makeGetIsSubprojectsExist()
      return (state: State, {projectId, wasVisible}: OwnProps) => {
        const project = getProject(state, projectId)

        return {
          isArchived: project?.archived ?? false,
          isExpanded: !getIsSubprojectCollapsed(state, projectId),
          hasSubprojects: wasVisible ? getHasSubprojects(state, projectId) : true,
          hasBuildTypes: getHasBuildConfigurations(state, projectId, false),
          name: project?.name,
        }
      }
    },
    (dispatch, {projectId}) => ({
      toggleSubproject: (expand: boolean) => dispatch(toggleSubproject(projectId, expand)),
    }),
  ),
)(Subproject)
